import styled from '@mui/material/styles/styled'
import '@whereby.com/browser-sdk/embed'
import { useEffect } from 'react'
import { MainColor, MainFrameBG } from '../../../pure-js/libs/Colors'
import config from '../Config'
import { BorderRadixes } from '../enums/BorderRadixes'
import { useTeam } from '../hooks/QueryHooks'
import useAppState from '../hooks/useAppState'
import useAppStateSession from '../hooks/useAppStateSession'
import { useTeamId } from '../hooks/useTeamId'
import { useUser } from '../hooks/useUser'
import { createWherebyMeeting } from '../libs/CloudFunctionsApiHandler'
import Box from './Box'
import { DashboardCallEmptyState } from './DashboardCallEmptyState'
import { getDisplayName } from './DashboardMyTeamItemViews'
import { DASHBOARD_CALL_PANEL_MIN_HEIGHT } from '../libs/HardCodedSizes'
import { smallSpacing } from '../enums/Spacings'
import { hasOngoingMeeting } from '../../../pure-js/libs/hasOngoingMeeting'

export const DashboardCall = ({ width = '100%' }: { width?: string }) => {
  const { state: sessionState, setState } = useAppStateSession()
  const { data: user } = useUser()

  const { state } = useAppState()
  const { data: team, isLoading } = useTeam(useTeamId())
  const wherebyMeeting = team?.metaData?.wherebyMeeting
  const room = wherebyMeeting?.hostRoomUrl || wherebyMeeting?.roomUrl
  const displayName = getDisplayName(user)

  useEffect(() => {
    if (isLoading) return
    const endDate = team?.metaData?.wherebyMeeting?.endDate
    if (hasOngoingMeeting({ endDate, team: team })) return

    createWherebyMeeting({}, state)
  }, [team, isLoading])

  if (!sessionState.shouldShowCall) return <DashboardCallEmptyState />

  if (!config.enableCall) return null

  if (!room) return null

  return (
    <Box width={width} fullHeight>
      <Container fullPadding fullWidth fullHeight align="center" style={{ minHeight: DASHBOARD_CALL_PANEL_MIN_HEIGHT }}>
        <InnerConatiner fullPadding fullWidth fullHeight spacing={smallSpacing}>
          <whereby-embed room={room} style={{ width: '100%', height: '100%' }} displayName={displayName} lang="sv" />
        </InnerConatiner>
      </Container>
    </Box>
  )
}

const Container = styled(Box)`
  border-radius: ${BorderRadixes.big};
  background-color: ${MainFrameBG};
`

const InnerConatiner = styled(Container)`
  border-radius: ${BorderRadixes.big};
  background-color: ${MainColor};
`
